__turbopack_context__.v({
  "button": "Button-module-scss-module__gPXjYW__button",
  "button-content": "Button-module-scss-module__gPXjYW__button-content",
  "button-icon": "Button-module-scss-module__gPXjYW__button-icon",
  "button-text-in": "Button-module-scss-module__gPXjYW__button-text-in",
  "button-text-out": "Button-module-scss-module__gPXjYW__button-text-out",
  "flair": "Button-module-scss-module__gPXjYW__flair",
  "flair-container": "Button-module-scss-module__gPXjYW__flair-container",
  "flair-icon": "Button-module-scss-module__gPXjYW__flair-icon",
  "loader-container": "Button-module-scss-module__gPXjYW__loader-container",
});
